import { Box, Divider, Typography } from "@mui/material";
import { formatDoctorNames, getEventDataForCustomerRating } from "../../utils/genericUtils";

import AvatarCustom from "../AvatarCustom/AvatarCustom";
import {
  CardListContainer,
} from "./AppointmentCard.style";
import { ClinicLocationIcon } from "../Icons";
import { GvSecondaryButtonCustom } from "../../styles/styledComponents";
import { IAppointmentDetails } from "../../services/appointment-list/appointment-list.interface";
import { MIXPANEL_EVENTS } from "../../config/mixPanelEvents";
import { MODALS } from "../../config/params";
import React from "react";
import ReviewRating from "../ReviewRatingComponent/ReviewRating";
import { fromUnixToFullDateNum } from "../../utils/unix-timestamp";
import { useAppointmentStore } from "../../hooks/redux-hooks/appointment-store/appointment.store";
import { useModal } from "../../context/ModalContext";
import { userActivityLogger } from "../../utils/mixpanel";

type IAppointmentCardProps = {
    visit: IAppointmentDetails;
    isMenu?: boolean;
    isReviewCard?: boolean;
}

const AppointmentCard = (props: IAppointmentCardProps) => {
  const { visit, isReviewCard=false } = props;
  const { setAppointmentDetails } = useAppointmentStore();
  const { openModal } = useModal();
  const appointmentTime = fromUnixToFullDateNum(visit.start_at, visit.location.timeZone);


  const appointmentType = visit?.appointmentType.split("-")[0];

  const handleAppointmentSelected = (visit: IAppointmentDetails) => {
    setAppointmentDetails(visit);
    openModal(MODALS.APPOINTMENT_REVIEW);
  };
  const { petName, day, month, resources, time } =
   getEventDataForCustomerRating(visit);

  const handleSeeFullReview = () => {
    setAppointmentDetails(visit);
    userActivityLogger(MIXPANEL_EVENTS.SEE_FULL_REVIEW_BUTTON_CLICKED,
      {
        pet_name: petName || "",
        doctor_name: formatDoctorNames(resources) || "",
        date: `${month} ${day}` || "",
        time_slot: time || "",
      });
    openModal(MODALS.VIEW_RATING_REVIEW_MODAL);
  };

  return (
    <CardListContainer>
      <Box className="flex items-start gap-3 self-stretch" onClick={()=>handleAppointmentSelected(visit)}>
        <Box className="flex gap-3 flex-1 items-start">
          <AvatarCustom
            image={visit.pet?.image}
            width={56}
            height={56}
            name={visit.pet?.name}
          />
          <Box className="flex flex-col gap-1">
            <Box className={`flex gap-[1px] items-start h-full
              w-fit flex-wrap border-b border-solid
              border-gv-yellow-dark pb-1`}>
              <Typography variant="body1" fontWeight={600}>{appointmentTime.weekday}</Typography>
              <Divider orientation="vertical" className="!self-center !mx-[0.2rem] !border-[1px] !border-gray-3 !h-3"/>
              <Typography variant="body1">{appointmentTime.month} {appointmentTime.day} .&nbsp;</Typography>
              <Typography variant="body1">{appointmentTime.time}</Typography>
            </Box>
            <Typography variant="h3" fontWeight={600} >{visit.pet?.name}&apos;s {appointmentType}</Typography>
            <Box className="flex items-center gap-[1px]">
              <ClinicLocationIcon width={14} height={14} color="#908E8D"/>
              <Typography variant="body1" sx={{ color: (theme)=>theme.palette.gray.dark }}>
                {visit.location?.city}</Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      {/* Review Card for full Review */}
      {isReviewCard &&
       <div className="flex p-2 items-center self-stretch gap-2 border border-taupe-50 rounded-lg cursor-default">
         <div className="flex flex-col gap-2 flex-1 items-start flex-grow">
           <p className="font-semibold text-sm">Your review</p>
           <ReviewRating iconHeight={24} iconWidth={24} value={+visit.feedback[0].answer} readonly/>
         </div>
         <div>
           <GvSecondaryButtonCustom size="medium" sx={{ bgcolor: "transparent",
             height: "42px", padding: "10px 20px" }} onClick={handleSeeFullReview}>
            See Full Review
           </GvSecondaryButtonCustom>
         </div>
       </div>
      }
    </CardListContainer>
  );
};

export default AppointmentCard;
